__webpack_require__.p = "/tokens-scale-badge/account-setup/";